import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { mapUrl } from '../../data';

export default function MapSection() {
  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col xs={12}>
            <Card className="map border-0">
              <CardBody className="p-0">
                <iframe
                  title="Google Maps Location"
                  src={mapUrl}
                  style={{ border: '0', width: '100%', height: '450px' }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}